// src/foundations/assets/potion/index.ts

import dream0Url from './dream_0.png';
import dream0GaugeUrl from './dream_0_gauge.png';
import dream100Url from './dream_100.png';
import dream100GaugeUrl from './dream_100_gauge.png';
import dream25Url from './dream_25.png';
import dream25GaugeUrl from './dream_25_gauge.png';
import dream50Url from './dream_50.png';
import dream50GaugeUrl from './dream_50_gauge.png';
import dream75Url from './dream_75.png';
import dream75GaugeUrl from './dream_75_gauge.png';
import dreamRefillUrl from './dream_refill.png';
import magicShampoo100Url from './magic_100.png';
import potion0GaugeUrl from './potion_0_gauge.png';
import magicPotion0GaugeUrl from './potion_0_magic_gauge.png';
import potion100GaugeUrl from './potion_100_gauge.png';
import magicPotion100GaugeUrl from './potion_100_magic_gauge.png';
import potion25GaugeUrl from './potion_25_gauge.png';
import magicPotion25GaugeUrl from './potion_25_magic_gauge.png';
import potion50GaugeUrl from './potion_50_gauge.png';
import magicPotion50GaugeUrl from './potion_50_magic_gauge.png';
import potion75GaugeUrl from './potion_75_gauge.png';
import magicPotion75GaugeUrl from './potion_75_magic_gauge.png';
import potionErrorGaugeUrl from './potion_error_gauge.png';
import potionLoadingGaugeUrl from './potion_loading_gauge.png';
import upgradeMagicPotionUrl from './upgradeMagicPotion.png';
import welcomeDreamPotionDarkUrl from './welcomeDreamPotion_dark.png';
import welcomeDreamPotion24hDarkUrl from './welcomeMagicPotion_24h_dark.png';
import welcomeSuperPotionDarkUrl from './welcomeMagicPotion_dark.png';
import welcomeNormalPotionDarkUrl from './welcomeNormalPotion_dark.png';

// --------------------
// Exports
// --------------------

export const UpgradeMagicPotion = upgradeMagicPotionUrl;
export const WelcomeDreamPotion24hDark = welcomeDreamPotion24hDarkUrl;
export const WelcomeDreamPotionDark = welcomeDreamPotionDarkUrl;
export const WelcomeNormalPotionDark = welcomeNormalPotionDarkUrl;
export const WelcomeSuperPotionDark = welcomeSuperPotionDarkUrl;

export const MagicPotion0Gauge = magicPotion0GaugeUrl;
export const MagicPotion25Gauge = magicPotion25GaugeUrl;
export const MagicPotion50Gauge = magicPotion50GaugeUrl;
export const MagicPotion75Gauge = magicPotion75GaugeUrl;
export const MagicPotion100Gauge = magicPotion100GaugeUrl;

export const Potion0Gauge = potion0GaugeUrl;
export const Potion25Gauge = potion25GaugeUrl;
export const Potion50Gauge = potion50GaugeUrl;
export const Potion75Gauge = potion75GaugeUrl;
export const Potion100Gauge = potion100GaugeUrl;

export const PotionLoadingGauge = potionLoadingGaugeUrl;
export const PotionErrorGauge = potionErrorGaugeUrl;

export const Dream0Gauge = dream0GaugeUrl;
export const Dream25Gauge = dream25GaugeUrl;
export const Dream50Gauge = dream50GaugeUrl;
export const Dream75Gauge = dream75GaugeUrl;
export const Dream100Gauge = dream100GaugeUrl;

export const DreamShampoo0 = dream0Url;
export const DreamShampoo25 = dream25Url;
export const DreamShampoo50 = dream50Url;
export const DreamShampoo75 = dream75Url;
export const DreamShampoo100 = dream100Url;

export const DreamRefill = dreamRefillUrl;

export const MagicShampoo100 = magicShampoo100Url;
